<template>
  <main id="client" class="page-container" v-if="$route.name === 'customers'">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <div class="table-container-clients">
      <div class="clients-toolbar">
        <router-link to="/home/clients/add-client" class="primary-btn">
          + Nuovo cliente
        </router-link>
      </div>

      <div class="tbl-wrap">
        <table class="tbl client-table">
          <thead>
            <tr>
              <th id="nome-cliente">Nome cliente</th>
              <th id="numero-evento">Numero eventi</th>
              <th id="ultimo-evento">Ultimo evento</th>
              <th id="ultimo-preventivo">Ultimo preventivo</th>
              <th class="actions-col"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(client, index) in allClients" :key="index">
              <tr class="client-row">
                <td>{{ client.clientName }}</td>
                <td>{{ client.numEvents }}</td>
                <td>{{ formatToLocalDate(client.lastEvent) }}</td>
                <td>{{ formatToLocalDate(client.lastQuote) }}</td>
                <td class="actions-cell">
                  <button
                    class="icons-button"
                    @click="goToEditClient(client.id)"
                    title="Modifica cliente"
                    aria-label="Modifica cliente"
                  >
                    <font-awesome-icon :icon="['fas', 'pen-to-square']" />
                  </button>
                  <button
                    class="icons-button"
                    @click="openArchiveModal(client)"
                    title="Archivia cliente"
                    aria-label="Archivia cliente"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-can']" />
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <!-- PAGINAZIONE -->
      <!-- <div class="pagination">
        <div class="search-container">
          <input
            type="text"
            v-model="searchTerm"
            @keyup.enter="onSearch"
            placeholder="Cerca clienti..."
            class="search-box"
          />
          <button
            v-if="searchTerm"
            @click="onResetSearch"
            class="clear-search-button"
          >
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div> -->
    </div>

    <VueFinalModal
      v-model="showArchiveModal"
      :clickToClose="!archiving"
      :escToClose="!archiving"
      classes="documents-modal"
      content-class="confirm-modal-content modal--archive"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="closeArchiveModal"
          :disabled="archiving"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
        <h3 class="modal__title">Archivia cliente</h3>
        <p class="modal__subtitle">
          Sei sicuro di voler archiviare
          <strong>{{ selectedClient?.clientName }}</strong
          >?
        </p>
        <div class="modal-actions">
          <!-- <button
            class="secondary-btn"
            @click="closeArchiveModal"
            :disabled="archiving"
          >
            Annulla
          </button> -->
          <button
            class="primary-btn confirm-btn"
            @click="confirmArchive"
            :disabled="archiving"
          >
            <span v-if="archiving">Archivia…</span>
            <span v-else>Archivia</span>
          </button>
        </div>
      </template>
    </VueFinalModal>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate } from "../utilities/formatting";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    ...mapGetters({
      allClients: "clients/list",
    }),
  },
  data() {
    return {
      // errorMessage: "",
      // successMessage: "",
      searchTerm: "",
      archiving: false,
      showArchiveModal: false,
      selectedClient: null,
    };
  },
  methods: {
    ...mapActions(["fetchClients", "archiveClient"]),
    formatToLocalDate,
    async getClients() {
      try {
        await this.fetchClients();
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.details ||
          "Errore durante il caricamento dei clienti.";
        console.error(error);
      }
    },
    goToEditClient(clientId) {
      this.$router.push({ name: "edit-client", params: { clientId } });
    },
    openArchiveModal(client) {
      this.selectedClient = client;
      this.showArchiveModal = true;
    },
    closeArchiveModal() {
      if (this.archiving) return;
      this.showArchiveModal = false;
      this.selectedClient = null;
    },
    async confirmArchive() {
      if (!this.selectedClient) return;
      try {
        this.archiving = true;
        const response = await this.archiveClient(this.selectedClient.id);

        if (response.status === 200) {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Cliente archiviato con successo."
          );
        }
        // this.$toast.success(this.successMessage);
      } catch (err) {
        // console.error(err);
        // const msg =
        this.toast.error(
          err?.response?.data?.details ||
            err?.response?.data?.error ||
            err?.message ||
            "Impossibile archiviare il cliente."
        );
        // this.errorMessage = msg;
        // this.$toast?.error?.(msg); // Se usi un plugin toast
      } finally {
        this.showArchiveModal = false;
        this.selectedClient = null;
        this.archiving = false;
        this.getClients();
      }
    },
    async onSearch() {
      try {
        await this.fetchClients({ page: 1, limit: 6, search: this.searchTerm });
      } catch (err) {
        // this.errorMessage =
        this.toast.error("Errore durante la ricerca.");
      }
    },
    async onResetSearch() {
      try {
        this.searchTerm = "";
        await this.fetchClients({ page: 1, limit: 6, search: "" });
      } catch {
        // this.errorMessage =
        this.toast.error("Errore durante il reset della ricerca.");
      }
    },
  },
  mounted() {
    this.getClients();
  },
};
</script>

<style src="../css/ClientPage.css" />
